import Bugsnag from '@bugsnag/js';

// Contrato com o lit-fe-portal-next (useRefreshOnAssessmentFinished): a tela de curso, em outra aba
// da mesma origem, recebe o evento "storage" desta chave e recarrega as notas.
export const ASSESSMENT_FINISHED_STORAGE_KEY = 'lit:assessment-finished';

export function notifyAssessmentFinished({ assessmentCode, courseCode }) {
  const event = { assessmentCode, courseCode, finishedAt: Date.now() };
  try {
    localStorage.setItem(ASSESSMENT_FINISHED_STORAGE_KEY, JSON.stringify(event));
  } catch (error) {
    Bugsnag.notify(error, report => {
      report.context = 'notifyAssessmentFinished';
    });
  }
}
